var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.Analyzer.value
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": _vm.Analyzer.text,
      "bgImage": "/images/sub/product/analyzer-bg.jpg",
      "image": "/images/sub/product/analyzer-img.png"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" We specialize in the design, manufacturing, and commissioning of Analyzer Package System for various industries, including oil and gas, petrochemical, mining, power generation, and many more. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" Analyzer Package System includes analyzer shelter, cabinet, and rack that are designed to accommodate various types of analyzers such as Gas chromatographs, IR analyzer, NIR analyzer, Total sulfur analyzer, and Analyzers for physical properties. We carefully select the analyzers from reputable manufacturers to ensure the highest quality and performance. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" Our analyzer package system also includes a sampling system to prepare samples for analysis, HVAC (Heating, Ventilation and Air Conditioning) to control the temperature and humidity inside the shelter, and safety systems to ensure the safe operation of the equipment. ")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" Our team of experienced engineers work closely with customers to understand their unique requirements and develop custom solutions that are tailored to their specific needs. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" We also provide expert technical support and maintenance services to ensure that your system is always running at peak performance. ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }